import { useState } from "react";
import { Volume1, Volume2, VolumeX } from "lucide-react";
import { beep, beepVolume, setBeepVolume } from "@/lib/beep";

// Loudness of the barcode-scan beep, saved on this device. Plays a test beep when you let go.
export default function BeepVolume({ compact = false }) {
  const [v, setV] = useState(beepVolume);
  const Icon = v === 0 ? VolumeX : v < 50 ? Volume1 : Volume2;
  return (
    <div className={`flex items-center gap-2 ${compact ? "text-[11px]" : "text-xs"} text-slate-600`} data-testid="beep-volume">
      <button type="button" onClick={() => { const n = v === 0 ? 50 : 0; setV(n); setBeepVolume(n); if (n) beep(true); }} aria-label={v === 0 ? "Turn scan beep on" : "Mute scan beep"}
        className="shrink-0 rounded-full p-1 text-slate-500 hover:text-[#0053DA]" data-testid="beep-volume-mute"><Icon className="h-4 w-4" /></button>
      {!compact && <span className="shrink-0">Scan beep</span>}
      <input type="range" min={0} max={100} step={5} value={v} aria-label="Scan beep volume" data-testid="beep-volume-slider"
        onChange={(e) => { const n = Number(e.target.value); setV(n); setBeepVolume(n); }}
        onPointerUp={() => beep(true)} onKeyUp={() => beep(true)}
        className="h-1.5 min-w-0 flex-1 cursor-pointer accent-[#0053DA]" />
      <span className="w-9 shrink-0 text-right font-mono" data-testid="beep-volume-value">{v === 0 ? "Off" : `${v}%`}</span>
    </div>
  );
}
